import { atom } from "jotai";
import ChangeSummaryRecord from "models/view-models/change-summary-record";

const ChangesSummaryAtom = atom<ChangeSummaryRecord[]>([]);
export default ChangesSummaryAtom;
